module.exports = __webpack_public_path__ + "static/media/manage_classes_zero_state.b24596a1.svg";